<template>
    <div>
        <container :active_path="path" :plate="'云项目'">
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" ref="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="楼盘名称">
                            <el-autocomplete v-model="form.project" 
                                value-key="name" 
                                placeholder="输入楼盘名称" 
                                clearable
                                size="mini"
                                :fetch-suggestions="querySearchAsync"  
                                @select="handleSelect"
                                @change="clearProId">
                            </el-autocomplete>
                        </el-form-item>
                        <el-form-item label="面积">
                            <div class="flex-box">
                                <el-input v-model="form.area[0]"></el-input>
                                <span>-</span>
                                <el-input v-model="form.area[1]"></el-input>
                            </div>
                            
                        </el-form-item>
                        <el-form-item label="价格">
                            <div class="flex-box">
                                <el-input v-model="form.price[0]"></el-input>
                                <span>-</span>
                                <el-input v-model="form.price[1]"></el-input>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="confirm">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="projectname" label="关联楼盘" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="type" label="类型" align="center"></el-table-column>
                        <el-table-column prop="projectCity" label="城市" align="center"></el-table-column>
                        <el-table-column label="户型" align="center">
                            <template slot-scope="s">
                                <span>{{s.row.room}}室{{s.row.drawing}}厅{{s.row.toilet}}卫</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="面积" align="center" show-overflow-tooltip>
                            <template slot-scope="s">
                                <div>
                                    <span v-for="(item, index) in s.row.area" :key="index"><span v-if="index!=0">-</span>{{item}}</span>㎡
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="价格" align="center">
                            <template slot-scope="s">{{s.row.price}}元/㎡</template>
                        </el-table-column>
                        <el-table-column label="状态" align="center">
                            <template slot-scope="s">{{s.row.sell}}</template>
                        </el-table-column>
                        <el-table-column prop="price" label="标签" align="center">
                            <template slot-scope="s">{{s.row.popularize?'主推':''}}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="210">
                            <template slot-scope="s">
                                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            path: '/project/house-type',
            form: {
                keyword: '',
                area: [],
                price: [],
                projectid: '',
                project: '',
            },
            tableData: [1],
            pageNo: 1,
            pagesize: 14,
            total: 0,
            loading: false,
            managedCity:'',
            subStation:false,
        }
    },
    mounted () {
        if (this.$route.query.project){
            var project = JSON.parse(this.$route.query.project);
            this.form.project = project.name;
            this.form.projectid = project._id['$oid'];
        }
        this.getTableData();
        let managedCity = this.$store.getters.getuser.city;
        if(managedCity === '全部'){
            managedCity = '';
        }else{
            this.subStation = true;
        }
        this.managedCity = managedCity;
    },
    methods: {
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        putaway(row) {
            var params = {
                id: row._id['$oid'],
                putaway: !row.putaway,
            }
            this.$api.projectTypePutaway(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableData();
                }
            )
        },
        del(row) {
            this.$confirm('是否确定删除当前户型').then(
                confirm=>{
                    var params = {
                        id: row._id['$oid']
                    }
                    this.$api.delProjectType(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTableData();
                        }
                    )
                },
                cancel=>{}
            )
        },
        edit(row) {
            var id = row._id['$oid'];
            let subStation = this.subStation;
            this.$router.push({path: '/project/house-type/edit', query: {id,subStation}})
        },
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        getTableData() {
            var params = {
                projectid: this.form.projectid,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                area: JSON.stringify(this.form.area),
                price: JSON.stringify(this.form.price)
            }
            this.$api.getProjectTypesList(params).then(
                data=>{
                    let {list, total} = data;
                    for (var li of list){
                        if (typeof li.area=='string'){
                            li.area = JSON.parse(li.area);
                            if (typeof li.area=='number'){
                                var arr = [li.area]
                                li.area = arr;
                            }
                        }
                    }
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        querySearchAsync(queryString, cb) {
            if (this.loading) return;
            console.log(queryString)
            var params = {
                name: queryString||'',
                region: '',
                price: '',
                pageNo: 1,
                pagesize: 5,
                city: this.managedCity,
            }
            this.loading = true;
            this.$api.getProjectList(params).then(
                data=>{
                    this.loading = false;
                    let {list} = data;
                    cb(list);
                }
            )
        },
        handleSelect(item) {
            this.form.projectid = item._id['$oid'];
        },
        clearProId(){
            this.form.projectid = '';
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path == "/project/house-type/edit"){
            this.getTableData();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/main.scss";
</style>